import React, {useContext} from 'react';
import {
  Switch,
  Route,
  Redirect,
  useRouteMatch
} from "react-router-dom";
import RotaLeaveView from "./RotaLeaveView";
import RotaLeaveCreate from "./RotaLeaveCreate";
import RotaLeaveList from "./RotaLeaveList";
import {store} from "../store";
import {hasScope} from "../helpers/scopes";

export default function RotaLeave() {
  let match = useRouteMatch();
  const {state} = useContext(store);
  const canWrite = hasScope(state.user, 'rota-leave:write');
  return (
    <Switch>
      <Route path={`${match.path}/create`}>
        {canWrite ? <RotaLeaveCreate /> : <Redirect to={match.path} />}
      </Route>
      <Route path={`${match.path}/:id`}>
        {canWrite ? <RotaLeaveView /> : <Redirect to={match.path} />}
      </Route>
      <Route path={match.path}>
        <RotaLeaveList />
      </Route>
    </Switch>
  );
}
